import { defineComponent as r, createElementBlock as t, openBlock as o, normalizeClass as n, unref as i, createElementVNode as a, createCommentVNode as l, toDisplayString as s } from "vue";
import { slugify as c } from "@scalar-org/helpers/url";
import { EditorClasses as d } from "../../../../styles.js";
const p = ["id"], m = {
  key: 0,
  class: "subheading",
  role: "doc-subtitle"
}, C = /* @__PURE__ */ r({
  __name: "ScalarPageTitle",
  props: {
    title: {},
    description: {}
  },
  setup(u) {
    return (e, f) => (o(), t("div", {
      class: n(i(d).PageTitle)
    }, [
      a("h1", {
        id: i(c)(e.title),
        class: "heading"
      }, s(e.title), 9, p),
      e.description ? (o(), t("p", m, s(e.description), 1)) : l("", !0)
    ], 2));
  }
});
export {
  C as default
};
